var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4862 8.86327L9.44128 0.824203C9.38336 0.766164 9.31456 0.720118 9.23881 0.688701C9.16307 0.657284 9.08188 0.641113 8.99988 0.641113C8.91788 0.641113 8.83668 0.657284 8.76094 0.688701C8.6852 0.720118 8.6164 0.766164 8.55847 0.824203L0.51355 8.86327C0.279175 9.09764 0.146362 9.416 0.146362 9.74803C0.146362 10.4375 0.706909 10.998 1.39636 10.998H2.24402V16.7344C2.24402 17.0801 2.52332 17.3594 2.86902 17.3594H7.74988V12.9844H9.93738V17.3594H15.1307C15.4764 17.3594 15.7557 17.0801 15.7557 16.7344V10.998H16.6034C16.9354 10.998 17.2538 10.8672 17.4882 10.6308C17.9745 10.1426 17.9745 9.35155 17.4862 8.86327Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarHome);
export default __webpack_public_path__ + "static/media/sidebar-home.8f303e7423920053d2a711ae2bac35e8.svg";
export { ForwardRef as ReactComponent };